import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=680eed47&scoped=true"
import script from "./Performance.vue?vue&type=script&lang=js"
export * from "./Performance.vue?vue&type=script&lang=js"
import style0 from "./Performance.vue?vue&type=style&index=0&id=680eed47&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680eed47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('680eed47')) {
      api.createRecord('680eed47', component.options)
    } else {
      api.reload('680eed47', component.options)
    }
    module.hot.accept("./Performance.vue?vue&type=template&id=680eed47&scoped=true", function () {
      api.rerender('680eed47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P2_Page/Invite/Performance.vue"
export default component.exports